import { teamConstants } from '../Constants';

const team = (team) => {
  return {
    type: teamConstants.TEAM_SUCCESS,
    payload: team
  }
}

export const teamActions = {
  team
};